(function () {
    'use strict';
    angular.module('app').directive('selectioncommandclearextracteddata', selectioncommand_clearextracteddata);
    selectioncommand_clearextracteddata.$inject = ['$window'];
    function selectioncommand_clearextracteddata($window) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
            },
            controller: 'clearextracteddata',
            templateUrl: 'app/selectioncommand/selectioncommand_clearextracteddata.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();